import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthB2CService } from 'common-web-core';
import { from, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authB2cService: AuthB2CService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isInWhiteList(req.url)) {
      return next.handle(req);
    }
    return from(
      this.authB2cService.getAccessToken().then((token) => {
        return req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
      })
    ).pipe(mergeMap((r) => next.handle(r)));
  }

  private isInWhiteList(url: string): boolean {
    let isInWhiteList = false;
    const whiteList = [
      'assets/static/configs/appSettings.json',
      'configuration/settings'
    ];
    whiteList.forEach((s) => {
      if (url.toLowerCase().includes(s.toLowerCase())) {
        isInWhiteList = true;
      }
    });
    return isInWhiteList;
  }
}
